/**
 * Initializes the multistep checkout process.
 * This function calls other functions to set up event listeners and manipulate the DOM
 * for handling various steps and payment method selections in the checkout process.
 */
const loadMultiStepCheckout = () => {
  identificationStep();
  billingStep();
  paymentStep();
  afterSwitchingTab();
  orderReceivedPage();
};

/**
 * Handles the identification step in the multistep checkout process.
 */
const identificationStep = () => {
  jQuery(function ($) {
    // Check if the current step is identification and call the corresponding view function.
    if ($(".wpmc-step-identification.current").length > 0) {
      stepIdentificationView();
    }
  });
};

/**
 * Handles the billing step in the multistep checkout process.
 */
const billingStep = () => {
  jQuery(function ($) {
    // Add tooltip to the billing SSN field.
    $("#billing_hetu_field .woocommerce-input-wrapper").prepend(
      `<div class='tooltipHetu'><span class='helper'><i class='far fa-exclamation-circle'></i></span><span class='tooltiptext'>${window.puhti_multistep.ssn_info}</span></div>`,
    );

    // Check if the current step is billing and call the corresponding view function.
    if ($(".wpmc-step-billing.current").length > 0) {
      stepBillingView();
    }
  });
};

/**
 * Handles the payment step in the multistep checkout process.
 */
const paymentStep = () => {
  jQuery(function ($) {
    addBenifitPaymentsHeader();

    /**
     * Adds an event listener for payment method selection.
     * When a payment method is clicked, it removes the selected classes from all payment methods,
     * adds the selected class to the clicked payment method, and unchecks any preselected Paytrail method.
     *
     * @param {string} selector - The jQuery selector for the payment method element.
     * @param {boolean} togglePadding
     */
    const handlePaymentMethodClick = (selector, togglePadding = false) => {
      $("form.checkout, form#order_review").on("click", selector, (event) => {
        removeSelectedClasses();
        $(event.currentTarget).addClass("selected");
        $(
          'input[type="radio"][name="wc_paytrail_ppa_preselected_method"]:checked',
        ).prop("checked", false);
        if (togglePadding) {
          addStripeActiveClass();
        }
      });
    };

    /**
     * Adds an event listener for the Paytrail payment method.
     * When the Paytrail method is clicked, it removes the selected classes from all payment methods,
     * adds the selected class to the clicked Paytrail method, checks the Paytrail payment method radio button,
     * and hides the Stripe payment box.
     */
    $("form.checkout, form#order_review").on(
      "click",
      ".wc-paytrail-ppa-method",
      (event) => {
        removeSelectedClasses();
        $(event.currentTarget).addClass("selected");
        $("#payment_method_paytrail_ppa").prop("checked", true);
        $(".payment_method_stripe_cc .payment_box").hide();
      },
    );

    // Add event listeners for ePassi and Stripe payment methods using the handlePaymentMethodClick function.
    handlePaymentMethodClick(".payment_method_epassi label");
    handlePaymentMethodClick(".payment_method_stripe_cc label", true);

    // Add selected class to the payment method label on checkout form update
    $(document.body).on("updated_checkout", function () {
      addBenifitPaymentsHeader();
      // Get the selected payment method label
      const selectedPaymentMethod = $(
        'input[type="radio"][name="payment_method"]:checked',
      );
      selectedPaymentMethod.siblings("label").addClass("selected");

      if (selectedPaymentMethod.val() === "stripe_cc") {
        addStripeActiveClass();
      }
    });

    /**
     * Removes the selected classes from all payment method labels.
     */
    function removeSelectedClasses() {
      console.debug("Removing selected classes");
      $(
        ".payment_method_stripe_cc label, .payment_method_epassi label, .wc-paytrail-ppa-method",
      ).removeClass("selected");
      $(".payment_method_paytrail_ppa").removeClass("stripe_active");
    }

    /**
     * Adds the stripe_active class to the Paytrail payment method.
     */
    function addStripeActiveClass() {
      $(".payment_method_paytrail_ppa").addClass("stripe_active");
    }

    /**
     * Adds a header for the benefit payment methods.
     */
    function addBenifitPaymentsHeader() {
      const epassiExists = $(".payment_method_epassi").length > 0;
      const stripeExists = $(".payment_method_stripe_cc").length > 0;
      const headerNotExists = $(".benefit-payments-header").length === 0;

      if (stripeExists) {
        observeStripeMutations();
        // Gray out and disable the Stripe payment gateway for now.
        const MULTISTEP_EXISTS = typeof MULTISTEP !== "undefined";
        grayOutPaymentGateway(
          ".payment_method_stripe_cc",
          MULTISTEP_EXISTS ? MULTISTEP.shouldGreyOut : true,
        );
      }

      if (epassiExists && headerNotExists) {
        $(".wc_payment_methods").prepend(
          `<div class="benefit-payments-header">${window.puhti_multistep.benefit_payment_methods}</div>`,
        );
      }
    }

    /**
     * Observes mutations in the Stripe payment box.
     * When error messages are shown or hidden, the padding of the Paytrail payment method is adjusted.
     */
    function observeStripeMutations() {
      // Select the target node
      const targetNode = document.querySelector(
        ".payment_box.payment_method_stripe_cc",
      );

      // Options for the observer (which mutations to observe)
      const config = { childList: true };

      // Callback function to execute when mutations are observed
      const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              if (
                node.nodeType === Node.ELEMENT_NODE &&
                node.classList.contains("woocommerce-NoticeGroup")
              ) {
                const paytrailElement = document.querySelector(
                  ".payment_box.payment_method_stripe_cc",
                );
                document
                  .querySelector(".payment_method_paytrail_ppa.stripe_active")
                  .setAttribute(
                    "style",
                    "padding-top: " +
                      paytrailElement.clientHeight +
                      "px !important",
                  );
              }
            });
            mutation.removedNodes.forEach((node) => {
              if (
                node.nodeType === Node.ELEMENT_NODE &&
                node.classList.contains("woocommerce-NoticeGroup")
              ) {
                $(".payment_method_paytrail_ppa.stripe_active").css(
                  "paddingTop",
                  "initial",
                );
              }
            });
          }
        }
      };

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    }
  });
};

/**
 * Handles switching tabs in the multistep checkout process.
 */
const afterSwitchingTab = () => {
  jQuery(function ($) {
    // Event listener for switching tabs in the checkout process.
    $(".woocommerce-checkout").on("wpmc_after_switching_tab", function () {
      if ($(".wpmc-step-identification.current").length > 0) {
        stepIdentificationView();
        return;
      }
      if ($(".wpmc-step-billing.current").length > 0) {
        stepBillingView();
        return;
      }
      $("#cart-page-content").hide();
      // Not sure if needed as it appears to be done already.
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
    });

    // Additional event listener for switching tabs.
    $(".wpmc-tab-item").on("wpmc_after_switching_tab", function () {
      console.log("wpmc_after_switching_tab");
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
    });
  });
};

/**
 * Hides the back button on the order received page.
 */
const orderReceivedPage = () => {
  // Hide the back button on the order received page.
  const orderReceived = document.querySelector(".woocommerce-order-received");
  if (orderReceived) {
    document.querySelector(".wp-block-button.icon-arrow-left").style.display =
      "none";
  }
};

/**
 * Updates the view for the identification step.
 * Hides and shows relevant elements for the identification step.
 */
function stepIdentificationView() {
  document.querySelector(".woocommerce-notices-wrapper").style.display = "none";
  document.querySelector("#checkout-info-personal").style.display = "none";
  document.querySelector("#checkout-info-report").style.display = "flex";
  document
    .querySelectorAll("#checkout-page-content .wp-block-spacer")
    .forEach((element) => {
      element.style.display = "none";
    });
  document
    .querySelector(".wpmc-nav-wrapper")
    .after(document.querySelector("#checkout-page-content"));
  document
    .querySelector(".wpmc-no-back-to-cart")
    .append(document.querySelector("#wpmc-next"));
}

/**
 * Updates the view for the billing step.
 * Hides and shows relevant elements for the billing step.
 */
function stepBillingView() {
  document.querySelector(".woocommerce-notices-wrapper").style.display = "none";
  document.querySelector("#checkout-info-personal").style.display = "flex";
  document.querySelector("#checkout-info-report").style.display = "none";
  document
    .querySelectorAll("#checkout-page-content .wp-block-spacer")
    .forEach((element) => {
      element.style.display = "none";
    });
  document
    .querySelector(".wpmc-steps-wrapper")
    .before(document.querySelector("#checkout-page-content"));
  document
    .querySelector(".wpmc-no-back-to-cart")
    .append(document.querySelector("#wpmc-next"));
}

/**
 * Gray out the payment gateway.
 * @param {string}  selector The selector for the payment gateway.
 * @param {boolean} shouldGrayOut Whether the payment gateway should be grayed out.
 */
function grayOutPaymentGateway(selector, shouldGrayOut) {
  const element = document.querySelector(selector);
  if (element) {
    if (shouldGrayOut) {
      element.classList.add("disabled");
    } else {
      element.classList.remove("disabled");
    }
  }
}

window.addEventListener("load", loadMultiStepCheckout);
